(function () {
    'use strict';

    // @ngInject
    function InvoiceTemplateEmptyStateControllerCtor($scope, $injector, AnalyticsService, TemplatesViewService, $state, AppStates) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'InvoiceTemplateEmptyStateController';
        AnalyticsService.trackPageView(this, 'InvoiceTemplateEmptyStateView');

        this.TemplatesViewService = TemplatesViewService;
        this.$state = $state;
        this.AppStates = AppStates;
    }

    Controllers.InvoiceTemplateEmptyStateController = Class(Controllers.BaseController, {
        constructor: InvoiceTemplateEmptyStateControllerCtor
    });
}());

